
export enum AnimationState {
  STARTED,
  IDLE,
  DRAWING,
  FINISHING,
  ERROR,
}

export enum GameStatus {
  ACTIVE,
  IDLE,
}

export enum GAME_MODE {
  INSTANT = 'instant',
  MULTIPLY = 'multiple',
}

export interface IFormInput {
  amount: string
  mode: GAME_MODE
  denom: string
}
